import React, { useState } from "react";
import { Link } from "react-router-dom";
import './style/Navbar.css';

const burger = document.querySelector(".hamburger");
const navmenu = document.querySelector(".nav-menu");

// burger.addEventListener("click", () => {
//   burger.classList.toggle("active");
//   navmenu.classList.toggle("active");

// })


// document.querySelectorAll(".nav-item").forEach(n => n.addEventListener("click", () => {
//   burger.classList.remove("active");
//   navmenu.classList.remove("active");
// }))
export default function Navbar() {
  const [toggle ,setToggle]=useState(true)
  const Htoggle = () => {
    setToggle(!toggle)
  }
  return (
    <>
      <nav className="NAVBAR Navbb navp">
        <div className="container- navc">
          <Link to="/">
          <img className="Img" src={require("./dizipro.png")} alt="Error" />
          
          </Link>
          <div className={`${toggle ? 'nav-menu':'nav-menu active '}`}>
            <Link className="nav-item text-light  " to="/">Home</Link>
            <Link className="nav-item text-light  " to="/portfolio">Portfolio</Link>
            <Link className="nav-item text-light  " to="/order">Order A Project</Link>
            <Link className="nav-item text-light  " to="/paid">Paid Courses</Link>
            <Link className="nav-item text-light  " to="/profil">Profile</Link>
          </div>
          <select name="" id="">
            <option value="">Eng</option>
            <option value="">Rus</option>
          </select>
          <Link className="btn btn-no" id="btn-no" to="/order">Order now</Link>
          <Link className="btn btn-1 bnt" to="/register">Register</Link>
          <div onClick={Htoggle} className="hamburger">
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
        </div>
      </nav>
    </>
  )
}